module.exports = __webpack_public_path__ + "static/img/cont48 (5).8ab99d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont48 (5).jpg
// module id = Q5i2
// module chunks = 0